'use es6';

import * as AchievementActions from './AchievementActions';
export default Object.assign({}, AchievementActions);